import React from 'react';
import { useNavigate } from 'react-router-dom';
import constants from '../config/consts';
import '../styles/AllCard.css';

const AllCard = ({ product, onClick }) => {
  const navigate = useNavigate();
  
  // Первое изображение из строки images (разделены запятой) или preViewImg
  const firstImage = product.images?.split(',')[0] || product.preViewImg;

  return (
    <div className="AllCard" onClick={onClick}>
      <div className="allCardImageContainer">
        <img className='allCardImage'
          src={`${constants.serverUrl}${firstImage}`} 
          alt={product.title} 
        />
      </div>
      <p className="allCardTitle">{product.title}</p>
    </div>
  );
};

export default AllCard;